import api from './api';
import type { AuthUser } from '../types';

export const authApi = {
  getMe: async (): Promise<AuthUser> => {
    return api.get('auth/me').json<AuthUser>();
  },
  login: async (email: string, password: string): Promise<AuthUser> => {
    return api.post('auth/login', { json: { email, password } }).json<AuthUser>();
  },
  register: async (name: string, email: string, password: string): Promise<AuthUser> => {
    return api.post('auth/register', { json: { name, email, password } }).json<AuthUser>();
  },
  logout: async (): Promise<void> => {
    await api.post('auth/logout').catch(() => {});
  },
  updateProfile: async (profileData: {
    name?: string;
    phoneNumber?: string;
    currentPassword?: string;
    newPassword?: string;
  }): Promise<AuthUser> => {
    return api.put('auth/profile', { json: profileData }).json<AuthUser>();
  },
  forgotPassword: async (email: string): Promise<void> => {
    await api.post('auth/forgot-password', { json: { email } });
  },
  resetPassword: async (token: string, password: string): Promise<void> => {
    await api.post('auth/reset-password', { json: { token, password } });
  },
};
